module.exports = __webpack_public_path__ + "img/20190725161138QQ截图20190725005707.a5b0e2ad.png";